import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {fetchWithToken, postWithToken} from "../../../api/apiBase";
import {useAuthInfo} from "@propelauth/react";
import React, {useContext, useEffect, useState} from "react";
import {BaseScopeModel, FullScopeModel} from "../ScopeModel";
import {DevBidFormConfig} from "../../project_conf/BidCustomDataConf";
import {SubmitHandler} from "react-hook-form";
import {useToast} from "../../ui/use-toast";
// import InviteBidderByEmail from "../../directory/InviteByEmail";
import {ScopeForm} from "../ScopeForm";
import {Card, CardContent, CardHeader, CardTitle} from "../../ui/card";

import {DeveloperBidSummarySD, ScopedDeveloperBidSummarySD} from "../../bid/bid_summary/DeveloperBidSummaryView";
import {ScopeDirectoryView} from "../../directory/Directory";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "../../ui/tabs";
import BidSummary, {BidTableDeveloperScoped} from "../../bid/BidTableView";
import {BidBaseModel} from "../../bid/bidding_model";
import {CompareBidsInline} from "../../developer/compareBids";
import {BidFilesCard} from "../../bid/BidFilesCard";


function DeveloperCompareScopesWrapper({onSovChanged}: { onSovChanged?: () => void }){
    const {accessToken} = useAuthInfo()
    const navigate = useNavigate();
    const [bids, setBids] = useState<BidBaseModel[] >([]);
    const {toast} = useToast()
    const {project_id, scope_id} = useParams<{ project_id: string, scope_id: string }>();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    useEffect(() => {
        let url;
        if(scope_id){
            url = `/projects/${project_id}/bidding/?scope_id=${scope_id}`
        } else {
            url = `/projects/${project_id}/bidding/`
        }
        fetchWithToken(url, accessToken as string)
            .then((data) => {
                // console.log(data);
                setBids(data)
            })
            .catch((err) => {
                toast({
                        title: "Error",
                        description: "Failed to load bids: " + JSON.stringify(err),
                        variant: "destructive",
                    })
            })
    }, [project_id])

    return <CompareBidsInline
                        selectedRows={selectedRows}
                        bids={bids}
                        onSovChanged={onSovChanged}/>
}



export function DeveloperScopeView() {
    const {accessToken} = useAuthInfo();
    const {project_id, scope_id} = useParams<string>();
    const {toast} = useToast();
    const [data, setData] = useState<FullScopeModel | null>(null);
    // const [isEditing, setIsEditing] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    // ?tab=compare - the bid page's "Compare bids" opens here
    const [searchParams] = useSearchParams();
    // compare gets the whole page - the scope card and SOV editor are hidden (not unmounted, so edits survive)
    const [tab, setTab] = useState<string>(searchParams.get("tab") ?? "summary");
    const [bidsComparing, setBidsComparing] = useState<boolean>(false);
    const comparing = tab === "compare" || (tab === "bids" && bidsComparing);
    // bumped when compare converts a plug to an SOV line - remounts the SOV editor so it reloads
    const [sovVersion, setSovVersion] = useState<number>(0);
    const onSovChanged = () => setSovVersion((v) => v + 1);

    const onTabChange = (value: string) => {
        setTab(value);
        // the bids tab remounts in table mode
        setBidsComparing(false);
    }

    const fetchData = async () => {
            if (accessToken) {
                try {
                    setIsLoading(true);
                    const response = await fetchWithToken(
                        `/projects/${project_id}/scope/${scope_id}`, accessToken);
                    setData(response);
                    setError(null);
                } catch (err) {
                    setError("Error loading Scope :(");
                } finally {
                    setIsLoading(false);
                }
            }
        };

    useEffect(() => {
        fetchData();
    }, [project_id, scope_id]);

    const handleSaveEdit = (newData: FullScopeModel) => {
        if (!accessToken) {
            return
        }
        // console.log(newData)
        postWithToken(
            `/projects/${project_id}/scope/${scope_id}`,
            JSON.stringify(newData),
            accessToken)
            .then((data) => {
                setData(newData)
                toast({
                    title: "Success!",
                    description: "Update successful",
                    variant: "default",
                });
            })
            .catch((error) => {
                toast({
                    title: "Error",
                    description: error.message || "Failed to update Scope.",
                    variant: "destructive",
                });
            });
    };


    const onInvite = (e: any) => {
        // todo -> refresh the directory and such
        fetchData()
    }

    return <>
        <div className={comparing ? "hidden" : ""}>
        <Card>
                {data ?
                    <ScopeForm
                        key={scope_id}
                        editable={true}
                        onSave={handleSaveEdit}
                        onSubmit={handleSaveEdit}
                        scope={data as FullScopeModel}
                        canInvite={true}
                        create={false}
                        onInvite={onInvite}
                        aside={data.root?.id ?
                            <BidFilesCard
                                key={scope_id}
                                folder_id={data.root.id}
                                canEdit={true}
                                parent_type="scope"
                                parent_id={scope_id}
                                emptyLabel="Drop scope documents here, or click to browse"/>
                            : undefined}
                    />
                    : <></>
                }
            {/*</CardContent>*/}
        </Card>
        <br/>
        </div>

        {/*Sumamry/invites*/}
        <Card>
            <CardContent className="container pt-4">
                <Tabs value={tab} onValueChange={onTabChange}>
                    <TabsList>
                        <TabsTrigger value="summary">Summary</TabsTrigger>
                        <TabsTrigger value="directory">Directory</TabsTrigger>
                        <TabsTrigger value="bids">Bids</TabsTrigger>
                        <TabsTrigger value="compare">Compare</TabsTrigger>
                    </TabsList>
                    <TabsContent value="summary">
                        <ScopedDeveloperBidSummarySD/>
                    </TabsContent>
                    <TabsContent value="directory">
                        <ScopeDirectoryView />
                    </TabsContent>
                    <TabsContent value="bids">
                        <BidTableDeveloperScoped
                            onViewModeChange={(mode) => setBidsComparing(mode === "compare")}
                            onSovChanged={onSovChanged}/>
                    </TabsContent>
                    <TabsContent value="compare">
                        <DeveloperCompareScopesWrapper onSovChanged={onSovChanged}/>
                    </TabsContent>
                </Tabs>
            </CardContent>
        </Card>

        {/*bid config*/}
        <div className={comparing ? "hidden" : ""}>
            <br/>
            <DevBidFormConfig key={sovVersion}/>
        </div>

    </>
}